select<!--
Copyright 2025 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
@if (scenarioEvent && scenarioEvent.steamfitterTask) {
<div>
  <div class="info-detail">
    <!-- Name -->
    <div class="single-detail center-self">
      <mat-form-field class="full-width">
        <mat-label>Name</mat-label>
        <input type="text" matInput placeholder="Name" [(ngModel)]="scenarioEvent.steamfitterTask.name"
          [disabled]="!canEdit" />
      </mat-form-field>
    </div>
    <!-- Description -->
    <div class="single-detail center-self">
      <mat-form-field class="full-width">
        <mat-label>Description</mat-label>
        <input type="text" matInput placeholder="Description" [(ngModel)]="scenarioEvent.steamfitterTask.description"
          [disabled]="!canEdit" />
      </mat-form-field>
    </div>
    <!-- Task Type -->
    <div class="single-detail center-self">
      <mat-form-field>
        <mat-label>Steamfitter Task Type</mat-label>
        <mat-select placeholder="Steamfitter Task Type" [(ngModel)]="scenarioEvent.steamfitterTask.taskType"
          [disabled]="!canEdit">
          @for (taskType of taskTypes; track taskType) {
          <mat-option value="{{ taskType }}">{{ taskType }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Notification -->
    @if (scenarioEvent.steamfitterTask.taskType === steamfitterIntegrationType.Notification) {
    <span>
      <div class="single-detail center-self">
        <mat-form-field class="full-width">
          <mat-label>Notification Text</mat-label>
          <input type="text" matInput placeholder="Notification Text"
            [(ngModel)]="scenarioEvent.steamfitterTask.actionParameters['notificationText']"
            [disabled]="!canEdit" />
        </mat-form-field>
      </div>
    </span>
    }
    <!-- Situation Update -->
    @if (scenarioEvent.steamfitterTask.taskType === steamfitterIntegrationType.SituationUpdate) {
    <span>
      <div class="single-detail center-self">
        <mat-form-field>
          <mat-label>Situation Date / Time</mat-label>
          <input matInput placeholder="Situation Date / Time"
            [(ngModel)]="scenarioEvent.steamfitterTask.actionParameters['situationTime']"
            [disabled]="!canEdit">
          <!-- <datetime-picker> -->
        </mat-form-field>
      </div>
      <div class="no-form-field-detail center-self">
        <p style="font-size: 13px; font-weight: 400; line-height: 1.125; letter-spacing: normal;">
          Situation Description
        </p>
        <div>
          <angular-editor [placeholder]="'Description'"
            [(ngModel)]="scenarioEvent.steamfitterTask.actionParameters['situationDescription']"
            [config]="canEdit ? editorConfig : viewConfig"></angular-editor>
        </div>
      </div>
    </span>
    }
    <!-- Email -->
    @if (scenarioEvent.steamfitterTask.taskType === steamfitterIntegrationType.Email) {
    <span>
      <div class="single-detail center-self">
        <mat-form-field class="full-width">
          <mat-label>From</mat-label>
          <input type="text" matInput placeholder="From"
            [(ngModel)]="scenarioEvent.steamfitterTask.actionParameters['EmailFrom']"
            [disabled]="!canEdit" />
        </mat-form-field>
      </div>
      <div class="single-detail center-self">
        <mat-form-field class="full-width">
          <mat-label>To</mat-label>
          <input type="text" matInput placeholder="To"
            [(ngModel)]="scenarioEvent.steamfitterTask.actionParameters['EmailTo']"
            [disabled]="!canEdit" />
        </mat-form-field>
      </div>
      <div class="single-detail center-self">
        <mat-form-field class="full-width">
          <mat-label>cc</mat-label>
          <input type="text" matInput placeholder="cc"
            [(ngModel)]="scenarioEvent.steamfitterTask.actionParameters['EmailCC']"
            [disabled]="!canEdit" />
        </mat-form-field>
      </div>
      <div class="single-detail center-self">
        <mat-form-field class="full-width">
          <mat-label>Subject</mat-label>
          <input type="text" matInput placeholder="Subject"
            [(ngModel)]="scenarioEvent.steamfitterTask.actionParameters['Subject']"
            [disabled]="!canEdit" />
        </mat-form-field>
      </div>
      <div class="single-detail center-self">
        <mat-form-field class="full-width">
          <mat-label>Message</mat-label>
          <input type="text" matInput placeholder="Message"
            [(ngModel)]="scenarioEvent.steamfitterTask.actionParameters['Message']"
            [disabled]="!canEdit" />
        </mat-form-field>
      </div>
      <div class="single-detail center-self">
        <mat-form-field class="full-width">
          <mat-label>Account</mat-label>
          <input type="text" matInput placeholder="Account"
            [(ngModel)]="scenarioEvent.steamfitterTask.actionParameters['Account']"
            [disabled]="!canEdit" />
        </mat-form-field>
      </div>
      <div class="single-detail center-self">
        <mat-form-field class="full-width">
          <mat-label>Mime Type</mat-label>
          <input type="text" matInput placeholder="Mime Type"
            [(ngModel)]="scenarioEvent.steamfitterTask.actionParameters['Mime']"
            [disabled]="!canEdit" />
        </mat-form-field>
      </div>
    </span>
    }
    <!-- http -->
    @if (scenarioEvent.steamfitterTask.taskType && scenarioEvent.steamfitterTask.taskType.startsWith('Http')) {
    <span>
      <div class="single-detail center-self">
        <mat-form-field class="full-width">
          <mat-label>URL</mat-label>
          <input type="text" matInput placeholder="URL"
            [(ngModel)]="scenarioEvent.steamfitterTask.actionParameters['Url']"
            [disabled]="!canEdit" />
        </mat-form-field>
      </div>
      <div class="single-detail center-self">
        <mat-form-field class="full-width">
          <mat-label>Body</mat-label>
          <input type="text" matInput placeholder="Body"
            [(ngModel)]="scenarioEvent.steamfitterTask.actionParameters['Body']"
            [disabled]="!canEdit" />
        </mat-form-field>
      </div>
      <div class="single-detail center-self">
        <mat-form-field class="full-width">
          <mat-label>Headers</mat-label>
          <input type="text" matInput placeholder="Headers"
            [(ngModel)]="scenarioEvent.steamfitterTask.actionParameters['Headers']"
            [disabled]="!canEdit" />
        </mat-form-field>
      </div>
    </span>
    }
  </div>
</div>
}
